import React, { useRef, useState } from "react";
import CssTransition from "../../component/layout/css-transition";

export default function ViewModal({ id, updateId, modalOpen, setModalOpen }) {
  const modalContent = useRef(null);
  const [updateuser, setUpdateUser] = useState([]);
  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-8 px-6 ">
            {/* Search form */}
            <h3 class="mb-8 text-xl font-medium text-gray-900 dark:text-white flex justify-center">
              View To Do
            </h3>
            <form class="w-full">
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    for="name"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    To Do Name
                  </label>
                  <input
                    name="name"
                    id="name"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    value={id.name}
                    required
                  />
                </div>

                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    for="name"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Status
                  </label>
                  <input
                    name="status"
                    id="status"
                    value={id.status}
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    required
                  />
                  {/* <select
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-700 focus:border-blue-700 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    id="status"
                    name="status"
                   
                    value={updateuser.status}
                    //aria-label="Default select example"
                  >
                    <option
                      value="1"
                      class="!bg-[--bg-color-500] hover:bg-violet-600 active:bg-violet-700"
                    >
                      Active
                    </option>
                    <option
                      value="0"
                      class="!bg-[--bg-color-500] hover:bg-violet-600 active:bg-violet-700"
                    >
                      Inactive
                    </option>
                  </select> */}
                </div>
              </div>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3">
                  <label
                    for="updatedAt"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Created At
                  </label>
                  <input
                    name="createdAt"
                    id="createdAt"
                    value={id.createdAt}
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    required
                  />
                </div>
                <div class="w-full md:w-1/2 px-3">
                  <label
                    for="updatedAt"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Updated At
                  </label>
                  <input
                    name="updatedAt"
                    id="updatedAt"
                    value={id.updatedAt}
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    required
                  />
                </div>
              </div>
              <div class="flex justify-end">
                <button
                  class="!bg-white border-slate-200 hover:border-slate-300 text-slate-600 rounded-lg text-sm px-5 py-2.5 mr-3"
                  type="button"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
}
